import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { Button, Card } from "@themesberg/react-bootstrap";
import { useTranslation } from "react-i18next";

const StatusSelector = ({ defaultStatus, onChange }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(defaultStatus || ""); // stores VALUE
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const { t } = useTranslation();

  const statusList = [
    { name: t("selectStatus"), value: "Select Status", color: "#6c757d" },
    { name: t("fixedStatuses.paid"), value: "Paid", color: "#28a745" },
    { name: t("fixedStatuses.installmentPayment"), value: "Installment payment", color: "#17a2b8" },
    { name: t("fixedStatuses.debtCollectionInitiated"), value: "Debt collection initiated", color: "#ffc107" },
    { name: t("fixedStatuses.courtDunningProcedure"), value: "Court dunning procedure", color: "#fd7e14" },
    { name: t("fixedStatuses.resubmissions"), value: "Resubmissions", color: "#6610f2" },
    { name: t("fixedStatuses.foreclosures"), value: "Foreclosures", color: "#dc3545" },
    { name: t("fixedStatuses.completed"), value: "Completed", color: "#20c997" },
    { name: t("fixedStatuses.cancellation"), value: "Cancellation", color: "#6c757d" },
  ];

  // When user selects a status
  const handleStatusClick = (status) => {

    if (onChange) onChange(status.value); // send only the value
    setCurrentStatus(status.value);
    setShowOptions(false);
  };


  const toggleDropdown = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.top + window.scrollY - 10,
        left: rect.left + window.scrollX,
      });
    }
    setShowOptions(!showOptions);
  };

  // Find the selected status object
  const selectedStatus = statusList.find((s) => s.value === currentStatus);

  return (
    <div ref={containerRef} style={{ display: "inline-block" }}>
      <Button
        style={{
          backgroundColor: selectedStatus?.color || "#6c757d",
          border: "none",
          fontWeight: "500",
          transition: "all 0.3s",
        }}
        onClick={toggleDropdown}
      >
        {selectedStatus?.name || `${t("selectStatus")}`}
      </Button>

      {showOptions &&
        ReactDOM.createPortal(
          <Card
            ref={dropdownRef}
            style={{
              position: "absolute",
              top: dropdownPosition.top + 50,
              left: dropdownPosition.left,
              zIndex: 9999,
              padding: "12px",
              minWidth: "450px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
              transition: "all 0.3s ease-in-out",
            }}
          >
            {statusList.map((status) => (
              <Button
                key={status.value}
                style={{
                  backgroundColor: status.color,
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px",
                  fontWeight: "500",
                  color: "#fff",
                  cursor: "pointer",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onClick={() => handleStatusClick(status)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                {status.name}
              </Button>
            ))}
          </Card>,
          document.body
        )}
    </div>
  );
};

export default StatusSelector;
